import { useState } from 'react';

export type SubmitStatus = 'idle' | 'loading' | 'success' | 'error';

export function useSubmitStatus() {
  const [status, setStatus] = useState<SubmitStatus>('idle');

  const wrap = async (fn: () => Promise<void>) => {
    setStatus('loading');
    try {
      await fn();
      setStatus('success');
      setTimeout(() => setStatus('idle'), 1500);
    } catch (err) {
      setStatus('error');
      console.error(err);
      setTimeout(() => setStatus('idle'), 1500);
    }
  };

  return { status, wrap };
}
